// extracted by mini-css-extract-plugin
module.exports = {"summary-list":"reservation-detail_summary-list_2gOs9","v-list__tile":"reservation-detail_v-list__tile_3t9Jc"};